import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtro'
})

// export class FiltroPipe implements PipeTransform {

//   transform(items: any[], searchText: string): any[] {
//     if (!items) return [];
//     let filteredItems = items;
//     if (!searchText) return items;

//     searchText = searchText.toLowerCase();

//     return items.filter(it => {
//       return (
//         (it.principio_ativo && it.principio_ativo.toLowerCase().includes(searchText)) ||
//         (it.tipo_dose && it.tipo_dose.toLowerCase().includes(searchText)) ||
//         (it.concentracao && it.concentracao.toLowerCase().includes(searchText)) ||
//         (it.forma_farmaceutica && it.forma_farmaceutica.toLowerCase().includes(searchText)) ||
//         (it.unidade_fornecimento && it.unidade_fornecimento.toLowerCase().includes(searchText))||
//         (it.descricao && it.descricao.toLowerCase().includes(searchText)) ||
//         (it.nomeReceituarioFavorito && it.nomeReceituarioFavorito.toLowerCase().includes(searchText))
//       );
//     });

   
//   }
  
// }

export class FiltroPipe implements PipeTransform {

  transform(items: any[], searchText: string, campoOrdenacao: string = 'principio_ativo'): any[] {
    if (!items) return [];
    
    // Aplica a filtragem
    let filteredItems = items;
    if (searchText) {
      searchText = searchText.toLowerCase();
      filteredItems = items.filter(it => {
        return (
          (it.principio_ativo && it.principio_ativo.toLowerCase().includes(searchText)) ||
          (it.tipo_dose && it.tipo_dose.toLowerCase().includes(searchText)) ||
          (it.concentracao && it.concentracao.toLowerCase().includes(searchText)) ||
          (it.forma_farmaceutica && it.forma_farmaceutica.toLowerCase().includes(searchText)) ||
          (it.unidade_fornecimento && it.unidade_fornecimento.toLowerCase().includes(searchText)) ||
          (it.descricao && it.descricao.toLowerCase().includes(searchText)) ||
          (it.nomeReceituarioFavorito && it.nomeReceituarioFavorito.toLowerCase().includes(searchText))
        );
      });
    }

    // Aplica a ordenação
    return filteredItems.sort((a, b) => {
      const valorA = a[campoOrdenacao] ? a[campoOrdenacao].toLowerCase() : '';
      const valorB = b[campoOrdenacao] ? b[campoOrdenacao].toLowerCase() : '';
      return valorA.localeCompare(valorB);
    });
  }
}

